import { booleanAttribute, Component, EventEmitter, Input, Output } from '@angular/core';
import { UserCompany } from '../../../interfaces';
import { UserService } from '../../../services/user.service';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-company-card',
  templateUrl: './company-card.component.html',
  styleUrl: './company-card.component.scss'
})
export class CompanyCardComponent {
  isOwner$: Observable<boolean> = this.userService.userInfo$.pipe(
    map((userInfo) => {
      if (!userInfo) {
        return false;
      }

      return userInfo.id === this.company.ownerUserAccountId;
    })
  )

  @Input({ required: true }) company!: UserCompany;
  @Input({ transform: booleanAttribute }) active: boolean = false;
  @Output() companySelected = new EventEmitter<number>();

  constructor(
    private userService: UserService
  ) {}

  onCardClick(): void {
    this.companySelected.next(this.company.id);
  }
}
